const MIME = {
    text: 'text/plain',
    json: 'application/json',
    pdf: 'application/pdf',
}

const ENCODING = {
    utf8: 'charset=utf8',
    base64: 'base64',
}

export default class DataBuilder {
    private content: string = ''

    private mime = MIME.text
    private encoding = ENCODING.utf8
    private args: Record<string, string> = {}

    constructor(content: string) {
        this.content = content ?? ''
    }

    text() {
        this.mime = MIME.text
        return this
    }

    json() {
        this.mime = MIME.json
        return this
    }

    pdf() {
        this.mime = MIME.pdf
        return this
    }

    utf8() {
        this.encoding = ENCODING.utf8
        return this
    }

    base64() {
        this.encoding = ENCODING.base64
        return this
    }

    fragment(name: string, value: string | number) {
        this.args[name] = value.toString()
        return this
    }

    fragmentString() {
        if (!Object.keys(this.args).length) return ''
        const args = []
        for (const name in this.args) {
            const arg = `${name}=${this.args[name]}`
            args.push(arg)
        }
        return '#' + args.join('&')
    }

    toString() {
        return `data:${this.mime};${this.encoding},${this.content}${this.fragmentString()}`
    }
}
